import { render, staticRenderFns } from "./MovimientosStock.vue?vue&type=template&id=492f3ae8"
import script from "./MovimientosStock.vue?vue&type=script&lang=js"
export * from "./MovimientosStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports